import Vue, { getCurrentInstance, computed } from "vue";
function useModelMigration(oldModelName, oldModelEvent, required = false) {
  const vm = getCurrentInstance().proxy;
  if (required && vm.$props[oldModelName] === void 0 && vm.$props.modelValue === void 0) {
    Vue.util.warn(`Missing required prop: "modelValue" or old "${oldModelName}"`);
  }
  const model = computed({
    get() {
      if (vm.$props[oldModelName] !== void 0) {
        return vm.$props[oldModelName];
      }
      return vm.$props.modelValue;
    },
    set(value) {
      vm.$emit(oldModelEvent, value);
      vm.$emit("update:modelValue", value);
      vm.$emit("update:model-value", value);
    }
  });
  return model;
}
export {
  useModelMigration as u
};
